var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    [
      _c("every", {
        ref: "everys",
        attrs: {
          type: _vm.type_,
          tag: _vm.tag_,
          "time-unit": _vm.timeUnit,
          symbol: _vm.symbol,
        },
        on: { "type-changed": _vm.changeType, "tag-changed": _vm.changeTag },
      }),
      _c("period", {
        ref: "periods",
        attrs: {
          type: _vm.type_,
          tag: _vm.tag_,
          size: _vm.size,
          "time-unit": _vm.timeUnit,
          "start-config": _vm.startConfig,
          "cycle-config": _vm.cycleConfig,
        },
        on: { "type-changed": _vm.changeType, "tag-changed": _vm.changeTag },
      }),
      _c("range", {
        ref: "ranges",
        attrs: {
          type: _vm.type_,
          tag: _vm.tag_,
          size: _vm.size,
          "time-unit": _vm.timeUnit,
          "lower-config": _vm.lowerConfig,
          "upper-config": _vm.upperConfig,
        },
        on: { "type-changed": _vm.changeType, "tag-changed": _vm.changeTag },
      }),
      _c("fixed", {
        ref: "fixeds",
        attrs: {
          type: _vm.type_,
          tag: _vm.tag_,
          size: _vm.size,
          "time-unit": _vm.timeUnit,
          nums: _vm.nums,
        },
        on: { "type-changed": _vm.changeType, "tag-changed": _vm.changeTag },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }